import React from 'react';
import SEO from '../components/SEO';
import PropTypes from "prop-types";
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import Footer from '../container/Footer/Footer';
import data from "../data/work/workDetails.json";
import WorkDetailsContainer from '../container/Work/WorkDetailsContainer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import CallToActionThree from "../container/CallToAction/CallToActionThree";



const EducationalInstitutions = () => {
    return (
        <React.Fragment>
            <SEO title="Tetrahed || Industries Details" />
            <Header />
            <Breadcrumb
                image="images/bg/breadcrumb-bg-two.jpg"
                title={data[6]?.title}
                content="Home"
                contentTwo="Industries"
            />
            <WorkDetailsContainer data={data[6]} />
            <CallToActionThree titleContent="Explore the future of travel with Tetrahed, Inc." />
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

EducationalInstitutions.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.number
            ])
        })
    })
}

export default EducationalInstitutions;